export const LANGUAGES = { auto: '自动识别', de: '德语', en: '英语', fr: '法语', es: '西班牙语', it: '意大利语', pt: '葡萄牙语', nl: '荷兰语', pl: '波兰语', sv: '瑞典语', da: '丹麦语', fi: '芬兰语', no: '挪威语', cs: '捷克语', ro: '罗马尼亚语', hu: '匈牙利语', el: '希腊语', tr: '土耳其语', ar: '阿拉伯语', ja: '日语', ko: '韩语', zh: '中文', uk: '乌克兰语', ru: '俄语' };

export function readDraft(raw) {
  try {
    const value = JSON.parse(raw || '{}');
    return {
      source: typeof value.source === 'string' ? value.source : '',
      text: typeof value.text === 'string' ? value.text : '',
      language: LANGUAGES[value.language] ? value.language : 'auto',
      translatedSource: typeof value.translatedSource === 'string' ? value.translatedSource : null,
      translatedLanguage: typeof value.translatedLanguage === 'string' ? value.translatedLanguage : null,
      detected: LANGUAGES[value.detected] ? value.detected : '',
      attempted: value.attempted === true,
      attemptId: typeof value.attemptId === 'string' ? value.attemptId : null,
    };
  } catch { return readDraft('{}'); }
}

export function isCurrent(draft) {
  return !!draft.text.trim() && draft.source === draft.translatedSource && draft.language === draft.translatedLanguage;
}

export function acceptsTranslation(draft, snapshot, generation, currentGeneration) {
  return generation === currentGeneration && draft.source === snapshot.source && draft.language === snapshot.language;
}
